import { useEffect, useState } from 'react';
import config from 'src/common/config';
import { useStores } from 'src/common/stores';
import { imageDomainToProxyPathMap } from '../components/discord';
import { getPalette } from '../components/profile/utils/getPalette';
import { isInDiscordIFrame } from '../utils/discord';

const discordProxyHostname = new URL(config.discordOriginsMap.discordProxy).hostname;

function maybeTransformSrc(src) {
  if (!isInDiscordIFrame()) {
    return src;
  }

  const srcUrl = new URL(src);
  const proxyPath = imageDomainToProxyPathMap[srcUrl.hostname];

  if (proxyPath) {
    return src.replace(srcUrl.origin, `https://${discordProxyHostname}${proxyPath}`);
  }

  return src;
}

export function usePalette(guideId, src) {
  const { appStore } = useStores();
  const [interimState, setInterimState] = useState({ isLoading: true });
  const guideItemPalettes = appStore.guideItemPalettes();
  const setGuideItemPalette = appStore.setGuideItemPalette();
  const guideItemPalette = guideItemPalettes[guideId];

  useEffect(() => {
    if (!src || guideItemPalette) {
      return;
    }

    async function fetchPalette() {
      try {
        const palette = await getPalette(maybeTransformSrc(src));

        setGuideItemPalette(guideId, palette);
      } catch (error) {
        setInterimState({ error });
      }
    }

    fetchPalette();
  }, [src, guideItemPalette, guideId, setGuideItemPalette]);

  return guideItemPalette ?? interimState;
}
